import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { flowRevisionUrl } from 'automation-ui-routing/workflowsUrls';
import { jsx as _jsx } from "react/jsx-runtime";
const RevisionButton = ({
  flowId,
  version,
  external = true,
  onClick
}) => {
  const revisionLink = flowRevisionUrl(flowId, version);
  return /*#__PURE__*/_jsx(UIButton, {
    size: "extra-small",
    use: "tertiary-light",
    href: onClick ? undefined : revisionLink,
    onClick: onClick,
    external: external,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.revisionButton.label"
    })
  });
};
export default RevisionButton;